import { useMemo } from 'react';

import { PageViewedTracker } from '@zenbusiness/application-commons-clickstream';
import { WebView } from '@zenbusiness/application-commons-webview';
import Box from '@zenbusiness/zui/Box';
import { useLocation } from 'react-router-dom';

import { Breadcrumbs } from '#client/components/Breadcrumbs';
import { DisableLayer } from '#client/components/DisableLayer';
import { FocusGrid, HubContainerGridStyled, HubMainWrapperStyled } from '#client/components/Grid';
import Notifications from '#client/components/Notifications';
import TransactionHistory from '#client/components/TransactionHistory';
import useDisableDashboardContext from '#client/hooks/useDisableDashboardContext';

import { BreadcrumbWrapStyled } from '../SharedStyles';

const { isWebView } = WebView;

export default function TransactionHistoryPage() {
  const { pathname } = useLocation();
  const { isDisable } = useDisableDashboardContext();

  const properties = useMemo(
    () => ({
      customDestinationPageName_: 'transaction_history_banking',
      appPageName: 'transaction_history_banking',
      appSection: 'banking',
      experienceOrigin: 'dashboard'
    }),
    []
  );

  return (
    <HubContainerGridStyled>
      <FocusGrid>
        <HubMainWrapperStyled>
          {!isWebView && (
            <BreadcrumbWrapStyled>
              <Breadcrumbs
                items={[
                  {
                    to: '../../finances',
                    label: 'Finances'
                  },
                  {
                    to: '../dashboard',
                    label: 'Banking'
                  },
                  {
                    label: 'Transactions'
                  }
                ]}
              />
            </BreadcrumbWrapStyled>
          )}
          <Notifications />
          <PageViewedTracker
            {...properties}
            key={pathname}
          />
          <Box position="relative">
            {isDisable && <DisableLayer aria-label="Disable layer" />}
            <TransactionHistory />
          </Box>
        </HubMainWrapperStyled>
      </FocusGrid>
    </HubContainerGridStyled>
  );
}
